// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Caml_obj from "rescript/lib/es6/caml_obj.js";
import * as Belt_Array from "rescript/lib/es6/belt_Array.js";
import * as Belt_Option from "rescript/lib/es6/belt_Option.js";
import * as Caml_option from "rescript/lib/es6/caml_option.js";

function getCityStatePostalCodeText(city, state, postalCode) {
  if (city === "") {
    if (state !== undefined) {
      if (postalCode === "") {
        return state;
      } else {
        return state + (" " + postalCode);
      }
    }
    if (postalCode === "") {
      return ;
    }
    
  }
  if (state !== undefined) {
    if (postalCode === "") {
      return city + (", " + state);
    } else {
      return city + (", " + (state + (" " + postalCode)));
    }
  } else if (postalCode === "") {
    return city;
  } else if (city === "") {
    return postalCode;
  } else {
    return city + (", " + postalCode);
  }
}

function addressLabel(addressLine1, addressLine2, addressLine3, city, region, postalCode, country) {
  return Belt_Option.getWithDefault(addressLine1, "") + Belt_Option.mapWithDefault(addressLine2, "", (function (a) {
                return ", " + a;
              })) + Belt_Option.mapWithDefault(addressLine3, "", (function (a) {
                return ", " + a;
              })) + Belt_Option.mapWithDefault(getCityStatePostalCodeText(Belt_Option.getWithDefault(city, ""), region, Belt_Option.getWithDefault(postalCode, "")), "", (function (str) {
                return ", " + str;
              })) + Belt_Option.mapWithDefault(country, "", (function (c) {
                return ", " + c;
              }));
}

function addressLabelUniversal(address) {
  if (address.TAG === /* Billing */0) {
    var a = address._0;
    return addressLabel(a.addressLine1, a.addressLine2, a.addressLine3, a.city, a.regionCode, a.postalCode, Belt_Option.flatMap(a.country, (function (c) {
                      return c.name;
                    })));
  }
  var a$1 = address._0;
  return addressLabel(a$1.addressLine1, a$1.addressLine2, a$1.addressLine3, a$1.city, a$1.regionCode, a$1.postalCode, Belt_Option.flatMap(a$1.country, (function (c) {
                    return c.name;
                  })));
}

function getAuctionLocationType(auctionLocation) {
  var match = Belt_Option.getWithDefault(auctionLocation, "").toLowerCase().replace(/\s+/g, "");
  switch (match) {
    case "beijing" :
        return "BEIJING";
    case "cologne" :
        return "COLOGNE";
    case "doha" :
        return "DOHA";
    case "dubai" :
        return "DUBAI";
    case "geneva" :
        return "GENEVA";
    case "hongkong" :
        return "HONG_KONG";
    case "london" :
        return "NEW_BOND_STREET";
    case "milan" :
        return "MILAN";
    case "mumbai" :
        return "MUMBAI";
    case "newyork" :
        return "NEW_YORK";
    case "paris" :
        return "PARIS";
    case "shanghaiauction" :
        return "SHANGHAI";
    case "zurich" :
        return "ZURICH";
    default:
      return ;
  }
}

function findShippingPreferenceBySaleLocation(saleLocation, shippingPreferences) {
  var saleLocationType = getAuctionLocationType(saleLocation);
  return Caml_option.undefined_to_opt(shippingPreferences.find(function (sp) {
                  return Caml_obj.equal(sp.location, saleLocationType);
                }));
}

function getAccountBillingAddress(partyAccount) {
  return Belt_Option.flatMap(Belt_Option.flatMap(partyAccount.addresses, (function (addresses) {
                    return Caml_option.undefined_to_opt(addresses.find(function (address) {
                                    return Belt_Option.flatMap(address, (function (address) {
                                                  return address.associationType;
                                                })) === "MAIN";
                                  }));
                  })), (function (a) {
                return a;
              }));
}

function getActivePartyAccounts(partyAccounts, activeAccounts, auctionLocation) {
  return partyAccounts.filter(function (x) {
                if (Caml_obj.notequal(x.role, "Bidding Agent")) {
                  return Belt_Option.mapWithDefault(x.legacyAccountNumber, false, (function (accountNumber) {
                                return activeAccounts.includes(accountNumber);
                              }));
                } else {
                  return false;
                }
              }).map(function (partyAccount) {
              var billingAddress = getAccountBillingAddress(partyAccount);
              var shippingAddress = Belt_Option.flatMap(findShippingPreferenceBySaleLocation(auctionLocation, Belt_Option.mapWithDefault(partyAccount.shippingPreferences, [], (function (sp) {
                              return Belt_Array.keepMap(sp, (function (p) {
                                            return p;
                                          }));
                            }))), (function (sp) {
                      return sp.address;
                    }));
              var address = shippingAddress !== undefined ? addressLabelUniversal({
                      TAG: /* ShippingPreferences */1,
                      _0: shippingAddress
                    }) : (
                  billingAddress !== undefined ? addressLabelUniversal({
                          TAG: /* Billing */0,
                          _0: billingAddress
                        }) : ""
                );
              var holderName = Belt_Option.getWithDefault(Belt_Option.flatMap(partyAccount.accountHolder, (function (a) {
                          return a.name;
                        })), "");
              var accountType = Belt_Option.mapWithDefault(partyAccount.accountType, "", (function (ac) {
                      return ac.charAt(0) + ac.slice(1).toLowerCase();
                    }));
              return {
                      id: Belt_Option.getWithDefault(partyAccount.legacyAccountNumber, ""),
                      holderName: "" + Belt_Option.getWithDefault(partyAccount.legacyAccountNumber, "") + " (" + holderName + ") " + accountType + "",
                      address: address
                    };
            });
}

export {
  getCityStatePostalCodeText ,
  addressLabel ,
  addressLabelUniversal ,
  getAuctionLocationType ,
  findShippingPreferenceBySaleLocation ,
  getAccountBillingAddress ,
  getActivePartyAccounts ,
}
/* No side effect */
